<script setup lang="ts">
import { Form } from 'vee-validate'
import { formLoginSchema } from '~/validate/forms/auth'
import { AUTH_CRITERIA } from '~/validate/constant/auth'
import { useLogin } from '~/composables/account/use-login'
import { useModal } from '~/composables/common/use-modal'
import { ModalCollection } from '~/constants'
import BaseButton from '~/components/common/base-button.vue'
import { useCommon } from '~/composables/common/use-common'
import UserIcon from '~/assets/images/icons/user-icon.svg'
import PasswordIcon from '~/assets/images/icons/password-icon.svg'
import BaseInput from '~/components/common/base-input.vue'
import { useIframe } from '~/composables/iframe/use-iframe'

const { user, messageError, handleSubmit, resetError, isButtonDisabled } = useLogin()
const { openModal } = useModal()
const { openLiveChat } = useCommon()
const { reloadGameIframe } = useIframe()
const handleLogin = async () => {
  handleSubmit().then(() => {
    reloadGameIframe()
  })
}
</script>
<template>
  <Form
    v-slot="{ isSubmitting, errors }"
    class="form"
    name="form-login"
    :validationSchema="formLoginSchema"
    @submit="handleLogin()"
  >
    <BaseInput
      v-model="user.username"
      type="text"
      label="Tên đăng nhập"
      name="username"
      :errorCustom="messageError"
      :maxLength="AUTH_CRITERIA.USER_NAME_MAX_LENGTH"
      className="required input-username"
      :isLabelFloating="true"
      :iconPrepend="UserIcon"
      @input="resetError"
      @onClearInput="resetError"
    />
    <BaseInput
      v-model="user.password"
      type="password"
      label="Mật khẩu"
      name="password"
      :maxLength="AUTH_CRITERIA.PASSWORD_MAX_LENGTH"
      className="required"
      :isLabelFloating="true"
      :iconPrepend="PasswordIcon"
      @input="resetError"
    />
    <div class="d-flex align-items-center justify-content-end">
      <p class="form__forgot-pass" @click="openModal(ModalCollection.FORGOT_PASSWORD, '', true)">
        <span>Quên mật khẩu?</span>
      </p>
    </div>
    <div class="form__btn-login">
      <BaseButton
        type="submit"
        size="extra-large"
        class="button"
        :isLoadingButton="isSubmitting"
        :disable="isButtonDisabled(isSubmitting, errors, messageError)"
      >
        Đăng nhập ngay
      </BaseButton>
    </div>
    <div class="form__help" @click="openLiveChat">
      <span class="live-chat"></span>
      <span>Live Chat</span>
    </div>
  </Form>
</template>
<style scoped lang="scss">
@import '~scssAsset/desktop/auth/form-auth.scss';
</style>
